import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import Modal from 'react-modal';
import axios from 'axios';

import style from './VoucherRedeemSection.module.less';
import { Section } from '../Section';

const REDEEM_URL = 'https://us-central1-eleven-puzzles-website.cloudfunctions.net/redeem';
// const REDEEM_URL = 'http://localhost:5001/eleven-puzzles-website/us-central1/redeem';

interface VoucherRedeemProps {
  alternate?: boolean;
  className?: string;
}

export const VoucherRedeemSection: React.FC<VoucherRedeemProps> = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onFinished = useCallback(async() => {
    try {
      setLoading(true);
      const response = await axios.post(REDEEM_URL, {
        code,
        email,
        token: 'EsKS5Cl6n244pvNf9DkGA6pc'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('response', response);
      if (response.data.success) {
        setLoading(false);
        setSuccess(true);
      } else {
        setError(response.data?.message || 'Something went wrong, please try again later');
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError('Something went wrong, please try again later');
      console.error(err);
    }
  }, [email, code]);

  return (
    <>
      <Section className={classNames(style.redeemSection, style.section, props.className)} alternate={props.alternate}>
        <h1 id="redeem">Want to reedem a code?</h1>
        <div className={style.row}>
          <div className={style.story}>
            <p>You're a lucky recipient of a voucher code, and want to redeem it? It's easy as a pie. Just click the button below and follow instructions.</p>
            <button type="button" className={style.redeem} onClick={() => setModalVisible(true)}>Redeem</button>
          </div>
        </div>
      </Section>
      <Modal
        isOpen={modalVisible}
        onRequestClose={() => setModalVisible(false)}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)'
          }
        }}
        contentLabel="Newsletter Modal"
      >
        <div className={style.modalContent}>
          {success ? (
            <>
              <h2>Thank you</h2>
              <button className={style.close} type="button" onClick={() => setModalVisible(false)}>X</button>
              <p>We e-mailed you the License Key. We hope you'll enjoy our game!</p>
            </>
          ) : (
            <>
              <h2>Redeem a voucher</h2>
              <button className={style.close} type="button" onClick={() => setModalVisible(false)}>X</button>
              {error ? <div className={style.errorMessage}>{error}</div> : <></>}
              <form
                onSubmit={(ev) => {
                  ev.preventDefault();
                  onFinished();
                }}
              >
                <div className={style.inputContainer}>
                  <p>Enter a code:</p>
                  <input
                    disabled={loading}
                    type="text"
                    name="CODE"
                    className={style.codeInput}
                    placeholder="VC-XXXXX-XXXXX"
                    onChange={ev => setCode(ev.target.value)}
                    value={code}
                  />
                </div>

                <div className={style.inputContainer}>
                  <p>Where we should send a confirmation?</p>
                  <input
                    disabled={loading}
                    type="email"
                    name="EMAIL"
                    className={style.emailInput}
                    placeholder="Enter your e-mail"
                    onChange={ev => setEmail(ev.target.value)}
                    value={email}
                  />
                </div>

                <button type="submit" className={style.redeem} disabled={loading}>{loading ? 'Redeeming...' : 'Redeem'}</button>
              </form>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};
